<template>
    <div class="toast-container position-fixed bottom-0 end-0 p-3">
        <div v-for="(toast_item, k) in toast_contents" class="toast" role="alert" aria-live="assertive" aria-atomic="true" :key="toast_item.key" :ref="toast_item.ref">
            <div class="toast-header">
                <!-- <img src="..." class="rounded me-2" alt="..."> -->
                <strong class="me-auto" v-html="toast_item.heading"></strong>
                <small></small>
                <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
            </div>
            <div class="toast-body" v-html="toast_item.body"></div>
        </div>
    </div>
</template>

<style>
    .toast-container {
        z-index: 100;
    }
</style>

<script>
    const default_layout = "default";

    export default {
        name: "ToastNotification",

        created() {},
        computed: {},

        data: function() {
            return {
                toast_contents: [{
                    heading: 'X',
                    body: 'D',
                    key: 0
                }],
                ctr: 0,
            };
        },

        methods: {
            addToast(data) {
                this.ctr ++;
                this.toast_contents.push({
                    heading: data.heading,
                    body: data.body,
                    key: Math.floor(Math.random() * 1000000),
                    ref: `toast-${this.ctr}`,
                });
            }
        },

        mounted() {
            this.eventHub.$on('toast_add', data => {
                this.addToast(data);
            });
        },

        updated() {
            (new bootstrap.Toast(this.$refs[`toast-${this.ctr}`][0])).show();
        },

        props: {},
    }
</script>